import { ecart as _ecart, ecartLabel as _ecartLabel, ecartClass as _ecartClass } from '@/utils/inventaire-helpers'
import { parseBackendTimestamp } from '@/utils/backend-timestamp'

export default {
  name: 'inventaire-detail-modal',
  props: {
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    inventaire: { type: Object, default: () => ({}) },
    resultats: { type: Array, default: () => [] },
    isAdmin: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    numeroInventaire(item) {
      return item.reference || ('INV-' + String(item.id).padStart(4, '0'))
    },
    statutLabel(statut) {
      const labels = {
        demande: this.isAdmin ? 'Demand\u00e9' : '\u00c0 faire',
        soumis: 'Soumis',
        correction_autorisee: 'Correction autoris\u00e9e',
        retabli: 'R\u00e9tabli',
      }
      return labels[statut] || 'En cours'
    },
    formatInventaireDate(dateStr) {
      if (!dateStr) return '-'
      const backendMatch = String(dateStr).match(/^(\d{2})-(\d{2})-(\d{4}) \u00e0 (\d{2}):(\d{2})/)
      if (backendMatch) {
        return `${backendMatch[1]}/${backendMatch[2]}/${backendMatch[3]} \u00e0 ${backendMatch[4]}h${backendMatch[5]}`
      }
      const date = parseBackendTimestamp(dateStr)
      if (Number.isNaN(date.getTime())) return dateStr
      const parts = this.getDatePartsInClinicTimezone(date)
      return `${parts.day}/${parts.month}/${parts.year} à ${parts.hour}h${parts.minute}`
    },
    detailPhysique(ligne) {
      return ligne.quantite_physique !== null && ligne.quantite_physique !== undefined ? ligne.quantite_physique : ligne.nombre
    },
    detailEcart(ligne) {
      return _ecart(this.detailPhysique(ligne), ligne.quantite_numerique)
    },
    detailEcartLabel(ligne) {
      return _ecartLabel(this.detailEcart(ligne))
    },
    detailEcartClass(ligne) {
      return _ecartClass(this.detailEcart(ligne))
    },
  },
}
